<template>
  <el-dialog :title="'【' + modelParam.task_id + '】' + modelParam.describe" center class="devOps-modelOne"
    :visible.sync="dialogVisible" width="90%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="130px">
      <el-form-item label="模块类型" prop="module_type">
        <el-select disabled style="width: 100%" v-model="form.module_type" placeholder="请选择模块类型">
          <el-option v-for="(value, key) in allSelect.TEXTMODULES" :key="key" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="部署环境" prop="env">
        <el-select style="width: 100%" v-model="form.env" placeholder="请选择部署环境">
          <el-option v-for="(item, index) in envs" :key="index" :label="item[0]" :value="item[1]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="额外部署SQL文件">
        <el-button style="font-size: 12px;letter-spacing:0px;padding: 10px 15px;" type="primary"
          @click="handleSqlDialogVisible('edit')">查看 / 编辑</el-button>
        <el-button style="font-size: 12px;letter-spacing:0px;padding: 10px 15px;" type="primary"
          @click="handleSqlDialogVisible('info')">复制到{{showGitDeploy ? 'GIT部署路径':'SQL'}}</el-button>
      </el-form-item>
      <el-form-item v-if="showGitDeploy" label="GIT部署分支" prop="ref">
        <el-input placeholder="请输入GIT部署分支" v-model="form.ref"></el-input>
      </el-form-item>
      <el-form-item v-if="showGitDeploy" label="GIT部署路径" prop="deploy_filepath">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 16 }"
          placeholder="请输入额外部署Git相对路径，多个以换行分隔，会以扩展名（.py/.sh/.sql/.conf等）区分部署类型" v-model="form.deploy_filepath">
        </el-input>
      </el-form-item>

      <el-form-item label="部署SQL语句" prop="sqlcontent">
        <Codemirror v-if="sqleditorVisible" ref="sqleditor" :value="form.sqlcontent"
          @changeTextarea="changeTextarea($event, 'sqlcontent')" />
        <div v-else style="height:100px;border: 1px solid #DCDFE6;"></div>
      </el-form-item>
      <el-form-item>
        <el-button :loading="runLoading" type="warning" @click="onSubmit('run')">执 行</el-button>
        <el-button :loading="skipLoading" type="warning" @click="onSubmit('skip')">跳 过</el-button>
        <el-button style="margin-top:5px;" type="warning" @click="onSubmit('log')">实时日志</el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi">查看历史</el-button>
        <el-button type="success" @click="handleClose">关 闭</el-button>
      </el-form-item>
    </el-form>
    <TableFive v-if="tableData.length" :moduleType="form.module_type" :tableData="tableData" />

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="88%" center
      title="额外部署SQL文件" :visible.sync="dialogSqlVisible" append-to-body>
      <Codemirror v-if="dialogSqlVisible" style="margin-bottom: 10px" sqlStyle="max-height:200px;" ref="sqlFileditor"
        :value="form.sqlExtracontent" @changeTextarea="changeTextarea($event, 'sqlExtracontent')" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSqlDialogVisible('save')">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
      title="生产环境执行SQL" v-if="sqlDoneVisible" :visible.sync="sqlDoneVisible" append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" v-html="webSocket.msg" class="tips-message websocket_style" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
      title="生产环境实时日志" v-if="releaseResultLogVisible" :visible.sync="releaseResultLogVisible" append-to-body>
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceStageSelectmapApi,
  getDevOpsSpaceListStageOutputApi,
  getEdiApi,
  postUpdateEdiApi,
} from "@/server/tops/devOps";
import { Progress, Editor, Codemirror, WebSocket } from "@/components/index.js";
import { TableFive } from "../table/index.js";
import { formatDate, } from "../util";
import { mapState, mapMutations } from "vuex";
export default {
  components: { TableFive, Progress, Editor, Codemirror, WebSocket },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        sqlExtracontent: ''
      },
      rules: {
        module_type: [
          { required: true, message: "请选择模块类型", trigger: "change" },
        ],
      },
      module_types: [],
      envs: [],
      message: "",
      runLoading: false,
      skipLoading: false,
      sqleditorVisible: true,
      tableData: [],
      quillEditorContent: {},
      dialogSqlVisible: false,
      sqlDoneVisible: false,
      releaseResultLogVisible:false
    };
  },
  computed: {
    ...mapState({
      progressBar: (state) => state.devOps.PROGRESSSBAR,
      allSelect: (state) => state.devOps.ALLSELECT,
      webSocket: (state) => state.devOps.WEBSOCKET
    }),
    showGitDeploy() {
      const { module_name = '', domain = '' } = this.modelParam;
      const newOrigin = `${module_name}.${domain}`;
      const origins = ['odoo.ehsy.com', 'mall.raxwell.cn']
      return origins.includes(newOrigin);
    }
  },
  async created() {
    this.form.module_type = this.modelParam.module_name;
    this.form.id = this.modelParam.task_id;
    this.form.pid = this.modelParam.pid;
    await this.queryDevOpsSpaceStageSelectmapApi();
     await this.queryDevOpsSpaceListStageParmInfo();
     await this.handleSqlDialogVisible('info');
  },
  updated() {
    this.scrollToBottom({ bind: this, refName: 'webSocket' })
  },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi() {
      try {
        const ret = await getDevOpsSpaceStageSelectmapApi();
        this.module_types = ret[this.modelParam.stage_name + "-module_type"];
        this.envs = ret[this.modelParam.stage_name + "-env"];
        this.form.env = ret[this.modelParam.stage_name + "-env"][0][1]
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let form = { ...this.form, ...ret.data, sqlcontent: '' };
          if (this.modelParam.stage_name !== 'tester_testExtraDeploy' && ret.data.sqlcontent) {
            form.sqlcontent = ret.data.sqlcontent
          }
          this.form = form;
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance.map((item) => {
            return {
              state: item?.output?.msg?.code,
              content: item.content,
              logtime: item.logtime,
              deploy_filepath: item?.output?.msg?.parms?.deploy_filepath || '',
              sqlcontent: item?.output?.msg?.parms?.sqlcontent || '',
              module_type: item?.output?.msg?.parms?.module_type || '',
            }
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      action === "run" && (await this.queryActionRunSubmit("run"));
      action === "skip" && (await this.queryActionSkipSubmit("skip"));
      action === "log" && (await this.queryActionNowLogSubmit(action));
    },
    // 实时日志
    async queryActionNowLogSubmit() {
      const {
        stage_id = "",
        task_id = "",
        pid = ''
      } = this.modelParam;
      this.tableData = [];
      this.releaseResultLogVisible = true;
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      this.openWebSocket({
        url: '/ws/devops',
        params: { pid, task_id, stage_id, username },
        title: '生产环境代码发布'
      })
    },
    // 预发环境sql 执行成功失败判断
    isSqlSuccess(output = {}) {
      if (typeof output === 'string') return false
      let flag = true;
      ["sql", "script", "conf"].forEach((i) => {
        if (output[i]?.length && output[i][0]?.code !== 0) {
          flag = false;
        }
      });
      return flag && output?.msg?.code === 0;
    },
    // 延迟设置进度条
    timeOutSetProgressBar(completeInfo, status = 'exception') {
      const initProgressBar = {
        percentage: 100,
        title: this.form.module || '',
        customColor: "",
      }
      setTimeout(() => {
        this.setProgressBar({
          ...initProgressBar,
          completeInfo,
          status,
        });
      }, 500)
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
            pid = ''
          } = this.modelParam;
          const {
            module_type = "",
            ref = "",
            deploy_filepath = "",
            env = "",
            sqlcontent = ''
          } = this.form;
          let param = {
            action,
            stage_id,
            task_id,
            stage_name,
            module_type,
            env,
            sqlcontent: sqlcontent || ''
          };
          if (module_type === 'odoo') {
            param.ref = ref;
            param.deploy_filepath = deploy_filepath;
          }
          try {
            this.runLoading = true;
            this.sqlDoneVisible = true;
            this.tableData = [];
            const cacheDate = new Date();
            const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
            this.openWebSocket({
              url: '/ws/devops',
              params: { pid, task_id, stage_id, username },
              title: '生产环境sql部署中'
            })
            const ret = await postDevopsSpaceStageActionApi(param);
            const output = ret?.data?.output || {};
            let isSuccess = this.isSqlSuccess(output);
            this.timeOutSetProgressBar(`SQL执行${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
            if (typeof output === 'string') {
              this.$notify({
                message: output || "数据错误",
                type: "error",
              });
            }
          } catch (error) {
            this.sqlDoneVisible = false;
            this.$notify({
              message: error || "数据错误",
              type: "error",
            });
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 跳过接口调用
    async queryActionSkipSubmit(action) {
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
      };
      try {
        this.skipLoading = true;
        const ret = await postDevopsSpaceStageActionApi(param);
        const { output = {} } = ret?.data || {};
        const message = (() => {
          if (typeof output === 'string') {
            return output
          }
          if (ret.status === 'failed') {
            if (Reflect.has(output, 'sql')) {
              return output.sql[0]?.msg
            }
            if (Reflect.has(output, 'deploy')) {
              return output.deploy[0]?.msg
            }
            return "跳过失败"
          } else {
            return "跳过成功"
          }
        })()
        this.$notify({
          message,
          type: ret.status === "success" ? "success" : "error",
        });
        ret.status === "success"
          ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
          : (this.message = JSON.stringify(ret.data || "", null, 2));
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.skipLoading = false;
        this.tableData = [];
      }
    },
    //设置sql语句
    changeTextarea(val, type) {
      this.$set(this.form, type, val);
    },
    // 额外部署sql
    async handleSqlDialogVisible(type) {
      const { id, pid } = this.form;
      let ret = {};
      try {
        switch (type) {
          case "info":
            this.sqleditorVisible = false;
            ret = await getEdiApi({ id, pid });
            this.showGitDeploy ? this.form.deploy_filepath = ret.data : this.form.sqlcontent = ret.data;
            break;
          case "edit":
            ret = await getEdiApi({ id, pid });
            this.form.sqlExtracontent = ret.data || "";
            break;
          case "save":
            ret = await postUpdateEdiApi({
              id,
              content: this.form.sqlExtracontent,
              pid,
            });
            break;
          default:
            break;
        }
        if (ret.status === "success") {
          if (type === 'info') return;
          this.dialogSqlVisible = type === "edit" ? true : false;
        } else {
          this.$notify({
            message: "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.sqleditorVisible = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 480px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}
</style>
<style lang="scss">
.devOps-modelOne {
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-textarea__inner {
    font-size: 14px !important;
    font-family: Arial, Helvetica, sans-serif;
    max-height: 400px;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 5px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>
